import {useFetch} from "../useFetch";
import {Counterparty} from "../../types/api/guide/counterparty.types";
import {counterpartyService} from "../../services/guide/counterparty-service";

export const useFetchAllCounterparty = () => {
    const { isLoading, error, data, refetch } = useFetch<Counterparty[]>(counterpartyService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
